import { parseCustomerKey } from '../config.js';
import { extractDomain } from '../index.js';
import { NON_SUBDOMAIN_EVENT_PATH, NON_SUBDOMAIN_SEARCH_PATH, SEARCH_API_DOMAINS, SUBDOMAIN_EVENT_PATH, SUBDOMAIN_SEARCH_PATH, } from './types.js';
/**
 * @desc: Depending of the value provided for api key, returns the host and the paths for the search api.
 * IMPORTANT: subdomain must be configured on CEC in order to be used.
 * @param customerKey
 * @param apiKey
 * @param customServiceHost
 * @param genericApiHost
 */
const composeAPIEndpoints = (customerKey, apiKey, customServiceHost, genericApiHost) => {
    if (apiKey) {
        return {
            apiDomain: genericApiHost,
            searchUrl: `${genericApiHost}${NON_SUBDOMAIN_SEARCH_PATH.replace('{{key}}', extractDomain(customerKey))}`,
            eventUrl: `${genericApiHost}${NON_SUBDOMAIN_EVENT_PATH.replace('{{key}}', customerKey)}`,
        };
    }
    return {
        apiDomain: customServiceHost,
        searchUrl: `${customServiceHost}${SUBDOMAIN_SEARCH_PATH}`,
        eventUrl: `${customServiceHost}${SUBDOMAIN_EVENT_PATH}`,
    };
};
const SitecoreSearchConfig = {
    build: (config, setupOptions) => {
        const newConfig = Object.assign({}, config, setupOptions);
        const { env = 'prod', customerKey = '' } = newConfig;
        const { serviceHost, apiKey } = setupOptions;
        const customerKeyData = parseCustomerKey(customerKey);
        if (!customerKeyData) {
            throw new Error(`Invalid customerKey: "${customerKey}". It should match the following pattern: (\\d+)-(\\d+). Example: 11111-2222222`);
        }
        const [domainId, domainHash] = customerKeyData;
        Object.assign(newConfig, {
            domainId,
            domainHash,
        });
        newConfig.connector = 'sitecore';
        if (!apiKey && !serviceHost) {
            throw new Error('Invalid configuration: "apiKey" has not been set but not serviceHost provided. Please, review your domain configuration');
        }
        return Object.assign(newConfig, composeAPIEndpoints(customerKey, apiKey, serviceHost, SEARCH_API_DOMAINS[env]));
    },
};
export default SitecoreSearchConfig;
